import { render, staticRenderFns } from "./SettingsTechnicalWork.vue?vue&type=template&id=5a8a0332&scoped=true&"
import script from "./SettingsTechnicalWork.vue?vue&type=script&lang=js&"
export * from "./SettingsTechnicalWork.vue?vue&type=script&lang=js&"
import style0 from "./SettingsTechnicalWork.vue?vue&type=style&index=0&id=5a8a0332&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8a0332",
  null
  
)

export default component.exports